<script setup lang="ts">
defineProps<{
    width?: string;
    height?: string;
    color?: string;
}>();
</script>

<template>
    <div
        class="flex justify-center items-center size-fit p-[0.8rem] rounded-full bg-white active:bg-custom-background-gray transition-all"
    >
        <svg
            :width="width || 16"
            :height="height || 16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.3081 15.5765C14.6951 15.9603 15.3227 15.9603 15.7097 15.5765C16.0968 15.1927 16.0968 14.5704 15.7097 14.1866L9.47006 7.99938L15.7085 1.81338C16.0955 1.42958 16.0955 0.807312 15.7085 0.423508C15.3214 0.0397042 14.6939 0.0397041 14.3068 0.423508L8.06841 6.6095L1.6932 0.287853C1.30615 -0.0959508 0.678606 -0.0959511 0.29155 0.287853C-0.0955055 0.671657 -0.0955051 1.29393 0.29155 1.67773L6.66676 7.99938L0.290291 14.3223C-0.0967637 14.7061 -0.096764 15.3283 0.290292 15.7121C0.677347 16.096 1.30489 16.096 1.69194 15.7121L8.06841 9.38925L14.3081 15.5765Z"
                :fill="color || '#85898A'"
            />
        </svg>
    </div>
</template>

<style scoped lang="scss"></style>
